// import axios from 'axios';
// import jsZip from 'jszip'
import CryptoJS from 'crypto-js' //npm install crypto-js --save
export default {
    //深克隆，无法克隆对象中的方法
    deepClone(obj) {                
        var objClone = JSON.parse(JSON.stringify(obj));
        return objClone;
    },
    creatGUID() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = Math.random()*16|0, v = c == 'x' ? r : (r&0x3|0x8);
            return v.toString(16);
        });
    },
    Trim(str){ 
        return str.replace(/(^\s*)|(\s*$)/g, ""); 
    },
    IsNumberString(str){
        return /^\d+$/.test(str);
    },
    TimeStamp2DateTime(ts){
        if (typeof(ts) == 'string') ts = Number(ts)
        var time = new Date(ts);
        return `${time.getFullYear()}年${time.getMonth()+1}月${time.getDate()}日 ${time.getHours()}:${time.getMinutes()}:${time.getSeconds()}`
    },
    createAES_ECB_Key(length){
        if (length%8!=0){
            length = length-length%8
            if (length<8){
                length = 8;
            } else if (length>32){
                length = 32;
            }
        }
        var key  = "";
        var char = 'ABCDEFGHIJKLMNPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz1234567890';
        for (var i=0;i<length;i++){
            key += char.charAt(Math.floor(Math.random() * char.length));
        }
        return key;
    },
    decode_base64(base64){
        // 对base64转编码
        var decode = atob(base64);
        // 编码转字符串
        var str = decodeURI(decode);
        return str;
    },
    //字符串转base64
    encode_base64(str){
    // 对字符串进行编码
        var encode = encodeURI(str);
        // 对编码的字符串转化base64
        var base64 = btoa(encode);
        return base64;
    },
    encodeUtf8Json(json){
        var strJson = JSON.stringify(json);
        var encoder = new TextEncoder();
        var uint8Array = encoder.encode(strJson);
        var strBinary = String.fromCharCode(...uint8Array);
        return btoa(strBinary);
    },
    //DES加密（originText：原始文本，key：密钥）
    encryptDES(originText, key){
        const keyHex = CryptoJS.enc.Utf8.parse(key)
        if (originText) {
            const encrypt = CryptoJS.DES.encrypt(originText, keyHex, {
                mode: CryptoJS.mode.ECB,
                padding: CryptoJS.pad.Pkcs7,
            })
            return encrypt.toString()
        }
        return ''
    },
    //DES解密（originText：加密文本，key：密钥）
    decryptDES(ciphertext, key){
        const keyHex = CryptoJS.enc.Utf8.parse(key)
        // console.log(keyHex);
        if (ciphertext) {
            const decrypted = CryptoJS.DES.decrypt(ciphertext, keyHex, {
                mode: CryptoJS.mode.ECB,
                padding: CryptoJS.pad.Pkcs7,
            })
            return decrypted.toString(CryptoJS.enc.Utf8)
        }
        return ''
    },
    // AES加密
    AES_ECB_ENCRYPT(text, secretKey) {
        var keyHex = CryptoJS.enc.Utf8.parse(secretKey);
        var messageHex = CryptoJS.enc.Utf8.parse(text);
        var encrypted = CryptoJS.AES.encrypt(text, keyHex, {
            "mode": CryptoJS.mode.ECB,
            "padding": CryptoJS.pad.Pkcs7
        });
        return encrypted.toString();
    },
    // AES解密
    AES_ECB_DECRYPT(textBase64, secretKey) {
        var keyHex = CryptoJS.enc.Utf8.parse(secretKey);
        // var text = CryptoJS.enc.Base64.parse(textBase64)
        // console.log(keyHex);
        // var textBase64 = CryptoJS.enc.Base64.stringify(textBase64)
        var decrypt = CryptoJS.AES.decrypt(textBase64, keyHex, {
            "mode": CryptoJS.mode.ECB,
            "padding": CryptoJS.pad.Pkcs7
        });
        // var strDecrypt=decrypt.toString(CryptoJS.enc.Utf8)
        return CryptoJS.enc.Utf8.stringify(decrypt).toString();
        // return strDecrypt.toString();
    },
    downloadBase64File(filedata,filename){
        try {
            var bstr = atob(filedata), n = bstr.length, u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            var myBlob = new Blob([u8arr]);
            var myUrl  = URL.createObjectURL(myBlob)
            var a      = document.createElement("a")
            a.setAttribute("href",myUrl)
            a.setAttribute("download",filename)
            a.setAttribute("target","_blank")
            let clickEvent = document.createEvent("MouseEvents");
            clickEvent.initEvent("click", true, true);  
            a.dispatchEvent(clickEvent);
        } catch (error) {
            return error;
        }         
        return "OK"
    },
    // downloadStreamFile(fileblob,filename){
    //     var zip = new jsZip();
    //     zip.loadAsync(fileblob, {optimizedBinaryString: true}).then(res => {
    //         // console.log(res);
    //         for (let key in res.files) {
    //         //判断是否是目录
    //             if (!res.files[key].dir) {
    //                 //找到我们压缩包所需要的json文件                    
    //                 res.file(res.files[key].name)
    //                 .async('blob')
    //                 .then(content => {
    //                     //得到我们需要的JSON文件内容
    //                     // console.log(content)
    //                     var myUrl = URL.createObjectURL(content)
    //                     var a     = document.createElement("a")
    //                     a.setAttribute("href",myUrl)
    //                     a.setAttribute("download",filename)
    //                     a.setAttribute("target","_blank")
    //                     let clickEvent = document.createEvent("MouseEvents");
    //                     clickEvent.initEvent("click", true, true);  
    //                     a.dispatchEvent(clickEvent);
    //                 })                    
    //             }
    //         } 
    //     })
    // },
    date2string(date,format) {
        //fomat为字符串，如：'Y-M-D-h-m-s'
        var Y       = date.getFullYear() + '';
        var M       = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1);
        var D       = (date.getDate()    < 10 ? '0'+(date.getDate())    : date.getDate());
        var h       = (date.getHours()   < 10 ? '0'+(date.getHours())   : date.getHours());
        var m       = (date.getMinutes() < 10 ? '0'+(date.getMinutes()) : date.getMinutes());
        var s       = (date.getSeconds() < 10 ? '0'+(date.getSeconds()) : date.getSeconds());
        var strDate = '';
        for (var key in format){
            switch (format[key]) {
                case 'Y': 
                    strDate += Y;
                    break;
            
                case 'M': 
                    strDate += M;
                    break;

                case 'D': 
                    strDate += D;
                    break;

                case 'h': 
                    strDate += h;
                    break;

                case 'm': 
                    strDate += m;
                    break;

                case 's': 
                    strDate += s;
                    break;

                default: 
                    strDate += format[key];
                    break;
            }
        }
        return strDate
    },
    getPrimeNumber(max){
        var arr           = [];
        var isPrimeNumber = function (arr,num) {
            if (num%2==0 && num!=2){
                return false;
            }
            if (num%3==0 && num!=3){
                return false;
            }
            if (num%5==0 && num!=5){
                return false;
            }
            for(var key in arr){
                if (num%arr[key] == 0){
                    return false;
                }
            }
            return true;
        }
        for (var key=2; key<=max; key++){
            if (isPrimeNumber(arr,key)){
                arr.push(key)
            }
        }
        return arr;
    },
    // async compress2Zip(file,name){
    //     var zip = new jsZip();
    //     zip.file(name,file);
    //     var result= await zip.generateAsync({
    //         type              : "blob",
    //         compression       : 'DEFLATE',
    //         compressionOptions: {
    //             level: 6,
    //         }
    //     })
    //     return result;
    // },
    blob2file(b,n){
        // console.log(b);
        var f=new window.File([b],n,{
            type: 'application/zip'
        });
        return f;
    },
    // loadJson(dir){
    //     return new Promise(resolve => {
    //         axios.get(dir).then((result) => {
    //             resolve(result);
    //         }).catch((error) => {
    //             console.log(error)
    //         })
    //     })
    // },
    sleep(delay) {
        for(var t = Date.now(); Date.now() - t <= delay;);
        // console.log(1);
    },    
    getHeaders(){
        var req = new XMLHttpRequest();
        req.open('GET', document.location.href, false);
        req.send(null);
        var headerArr = req.getAllResponseHeaders().split('\n');
        var headers = {};
        headerArr.forEach(item=>{
            if(item!==''){
                var index = item.indexOf(':');
                var key = item.slice(0,index);
                var value = item.slice(index+1).trim();
                headers[key] = value
            }
            
        })
        return headers
    },
    // 手机号验证
    validatePhoneNumber(phoneNumber) {
        if (phoneNumber.length !== 11) {
            return false;
        }
        var reg = /^1\d{10}$/;
        return reg.test(phoneNumber);
    },
    validateName(str){        
        var reg = /[^\u4e00-\u9FA5A-Z_a-z0-9]/g
        return reg.test(str);
    },
    
    saveAs(blob, filename) {
        if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, filename);
        } else {
            const link = document.createElement('a');
            const body = document.querySelector('body');
        
            link.href = window.URL.createObjectURL(blob);
            link.download = filename;
            // fix Firefox
            link.style.display = 'none';
            body.appendChild(link);
            link.click();
            body.removeChild(link);
            window.URL.revokeObjectURL(link.href);
        }
    },
    dealBlob(blob,f){
        const reader = new FileReader();
        reader.onload = function(event) {
            // 事件的result属性包含了转换后的数据
            const content = event.target.result;
            var msg = JSON.parse(content)
            // console.log(msg); // 输出转换后的字符串
            f(msg);
        };
        reader.readAsText(blob, 'UTF-8');
    }
}

